/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, useRef, useMemo } from "react";
import { Badge, Button, Combobox, Input } from "@repo/ui";
import { Link } from "react-router-dom";
import { CirclePlus, CircleX } from "lucide-react";
import { useLookupCashCenters } from "services/lookups-mutations";
import { Paths } from "routes/paths";
import { HasPermission } from "utils/helper";
import { useUser } from "hooks/use-user";
import { FaFileExport } from "react-icons/fa";
import { BiExport } from "react-icons/bi";

export default function FilterBarV2({
  getList = () => {},
  onExport = () => {},
  canExport = false,
}) {
  const [filters, setFilters] = useState({});
  const [selectedCashCenter, setSelectedCashCenter] = useState("");
  const [filter, setFilter] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);
  const filterTimeout = useRef(null);
  const user = useUser();
  const { mutate: getCashCenters, data: cashCentersList } =
    useLookupCashCenters();

  useEffect(() => {
    getCashCenters();
  }, []);

  useEffect(() => {
    if (filter !== null) {
      filterTimeout.current = setTimeout(() => {
        getList(
          filter || "",

          selectedCashCenter || ""
        );
        handleAddFilter("filter", filter, "Search");
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }
    };
  }, [filter]);
  useEffect(() => {
    if (!firstLoad) {
      getList(filter || "", selectedCashCenter || "");
    } else {
      setFirstLoad(false);
    }
  }, [selectedCashCenter]);
  const handleClearFilter = (key) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    if (key === "cashCenter") {
      setSelectedCashCenter("");
    } else if (key === "filter") {
      setFilter("");
    }
    setFilters({ ...updatedFilter });
  };
  const handleAddFilter = (key, value, name) => {
    if (value === "") {
      handleClearFilter(key);
      return;
    }
    const updatedFilter = { ...filters };

    updatedFilter[key] = `${name}: ${value}`;
    setFilters({ ...updatedFilter });
  };
  const clearAllFilters = () => {
    setFilters({});
    setSelectedCashCenter("");

    setFilter("");
  };

  const canAdd = useMemo(() => {
    return HasPermission(user, "User", "Add");
  }, [user]);
  return (
    <>
      <div className="flex mb-3 gap-1">
        <div className="min-w-[15%]">
          <Combobox
            placeholder="Select Cash Center"
            data={[
              { label: "Select Cash Center", value: "" },
              ...((cashCentersList?.data || []).map((elm) => ({
                label: elm.name,
                value: elm.cashCenterId,
              })) || []),
            ]}
            value={selectedCashCenter}
            setValue={(value) => {
              setSelectedCashCenter(value);
              let name = "";
              if (value !== "") {
                name = cashCentersList?.data.filter(
                  (elm) => elm.cashCenterId === value
                )[0].name;
              }
              handleAddFilter("cashCenter", name, "Cash Center");
            }}
          />
        </div>

        <div className="w-full">
          <Input
            value={filter}
            placeholder="Search"
            title="Search"
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
        </div>
        <div className="flex-1 flex flex-row justify-end gap-2">
          {" "}
          {canAdd ? (
            <Button
              variant="secondary"
              className="flex-1 flex flex-row justify-end gap-0"
              style={{ padding: 0 }}
            >
              <Link to={Paths.addUser}>
                <Button variant="secondary" className="flex flex-row gap-2">
                  <CirclePlus />
                  Create User
                </Button>
              </Link>
            </Button>
          ) : (
            <></>
          )}
          {canExport ? (
            <Button
              variant="secondary"
              className="flex flex-row gap-2"
              onClick={() => {
                onExport();
              }}
            >
              <BiExport />
              Export
            </Button>
          ) : null}
        </div>
      </div>
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.entries(filters).map(([key, value]) => (
          <Badge
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
            key={key}
          >
            {value}
            <CircleX
              onClick={() => {
                handleClearFilter(key);
              }}
            />
          </Badge>
        ))}
        {Object.keys(filters).length > 0 ? (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX
              onClick={() => {
                clearAllFilters();
              }}
            />
          </Badge>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
